import React from "react";
import {withNamespaces} from "react-i18next";

const SimpleConnectionStatus = ({status, hideDescription = false, translateKey = null, boldDesc = null, t}) => {

    return (
        <div>
        { status ?
            ( <div> {
                translateKey ?
                    <span>{t(translateKey)} :  </span> :
                    <React.Fragment/>
            } <i className="dvc-status fas fa-circle status-online"> </i> {
                !hideDescription ?
                    boldDesc ?
                        <b>{t('connected')}</b>:
                        <span>{t('connected')}</span>
                    : ""
            } </div> ) :
            ( <div>
                {
                    translateKey ?
                    <span>{t(translateKey)} : </span> :
                    <React.Fragment/>
                } <i className="dvc-status fas fa-circle status-offline"> </i> {
                !hideDescription ?
                    boldDesc ?
                        <b>{t('disconnected')}</b>:
                        <span>{t('disconnected')}</span>
                    :""
                } </div>
            )
        }
        </div>
    );
};
export default withNamespaces()(SimpleConnectionStatus);
